import Storage from './../services/Storage'

const checkPermission = (value) => {
    let userPermission = Storage.get('user')
    if(userPermission && userPermission.permission) {
        userPermission.indexOf(value)
    } 
    return userPermission !== -1;
}
export default checkPermission


// WEBPACK FOOTER //
// ./src/services/checkPermission.js